import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  ensureBotConfigForRoute,
  listBotsFromBotsList,
} from '../../config/getBotConfig';
import CreateNewBotForm from './createNewBotForm/CreateNewBotForm';
import classes from './AdminBotPicker.module.css';

export default function AdminBotPicker() {
  const navigate = useNavigate();
  const { texts } = useSelector((state) => state.translate);
  const [bots, setBots] = useState(() => listBotsFromBotsList());

  useEffect(() => {
    let cancelled = false;
    const listed = listBotsFromBotsList();

    Promise.all(
      listed.map(async (bot) => {
        try {
          const config = await ensureBotConfigForRoute(bot.projectKey, bot.botName);
          return {
            ...bot,
            activeInMyEdu: config?.activeInMyEdu === true,
            displayName: config?.displayName || config?.botTitle || bot.botName,
          };
        } catch {
          return {
            ...bot,
            activeInMyEdu: false,
            displayName: bot.displayName || bot.botName,
          };
        }
      })
    ).then((enriched) => {
      if (!cancelled) setBots(enriched);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={classes.wrap}>
      <h1 className={classes.title}>{texts.adminPickBotTitle}</h1>
      <p className={classes.sub}>
        {texts.adminPickBotSubtitle}
      </p>
      {bots.length === 0 ?
        <p className={classes.empty}>{texts.adminNoBotsConfigured}</p>
        :
        <ul className={classes.list}>
          {bots.map(({ projectKey, botName, routePath, displayName, activeInMyEdu }) => (
            <li key={routePath || `${projectKey}/${botName}`} className={classes.row}>
              <div className={classes.meta}>
                <span className={classes.project}>{projectKey}</span>
                <span className={classes.botName}>{displayName || botName}</span>
                <span
                  className={
                    activeInMyEdu ? classes.activeBadge : classes.inactiveBadge
                  }
                >
                  {activeInMyEdu ? texts.activeInMyEdu : texts.inactiveInMyEdu}
                </span>
              </div>
              <button
                type="button"
                className={classes.openBtn}
                onClick={() => navigate(`/admin/${routePath || `${projectKey}/${botName}`}`)}
              >
                {texts.edit}
              </button>
            </li>
          ))}
        </ul>
      }
      <CreateNewBotForm />
    </div>
  );
}
